import { useMutation, useQueryClient } from '@tanstack/react-query'

import { preferencesClient } from './preferences.service'

export const useNotificationPreferenceUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: preferencesClient.updateNotificationPreferences,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['currentNotificationPreferences'],
      })
    },
  })
}
